import FilterQuery, { Operator } from "../queries/FilterQuery";
import StringFilter from "./StringFilter";

export default class PhoneNumberFilter extends StringFilter {
  private readonly regex: RegExp = /[^0-9+]/g;

  toQuery() {
    return new FilterQuery(this.attribute, Operator.LIKE, this.value.replace(this.regex, ""));
  }
}
